import _ from 'lodash'
import config from 'scoreboard/components/config'

var sections = {

	fromType: function(type) {
		type = (type || '').toLowerCase()
		if ('scorecard-item' === type) {
			return 'scorecards'
		}
		return type + 's'
	},

	toType: function(section) {
		section = (section || '').toLowerCase()
		if ('scorecards' === section) {
			return 'scorecard-item'
		}
		if ('strategymaps' === section) {
			return 'strategy-map'
		}
		return section.substr(0, section.length-1)
	},

	/**
	 * Converts section from the camel-case format used most places (eg 'strategyMaps')
	 * to the kebab-case API format (eg 'strategy-maps')
	 */
	toUrl: function (section) {
		return _.kebabCase(section)
	},

	/**
	 * Converts section from the kebab-case API format (eg 'strategy-maps')
	 * to the camel-case format used elsewhere (eg 'strategyMaps')
	 */
	fromUrl: function (urlSection) {
		return _.camelCase(urlSection)
	},

	/**
	 * Given a section, or lack thereof return the section that should be displayed
	 * to the user.
	 *
	 * @param section
	 */
	default: function(section) {
		return section || (config.displayStrategyMaps ? 'strategy-maps' : 'dashboards')
	},

	organizations: {
		forest: false
	},

	scorecards: {
		forest: false
	},

	dashboards: {
		forest: true
	},

	initiatives: {
		forest: true
	},

	files: {
		forest: true
	},

	reports: {
		forest: true
	},

	charts: {
		forest: true
	},

	forms: {
		forest: true
	},

	ALERTS,
	ADMIN,
	DASHBOARD,
	BOOKMARKS,
	BRIEFING_BOOKS,
	BRIEFINGS,
	SCORECARDS,
	DOCUMENTS,
	IMAGES,
	INITIATIVES,
	REPORTS,
	ADMINISTRATION,
	GETTING_STARTED,
	DATASETS,
	DATASET_TREES,
	STRATEGY_MAPS,
	PROJECTS,
	SCHEDULED_EXPORTS,
	CHARTS,
	FORMS,
	ORGANIZATIONS

}

export const ALERTS = 'alerts'
export const ADMIN = 'admin'
export const DASHBOARD = 'dashboards'
export const BOOKMARKS = 'bookmarks'
export const BRIEFING_BOOKS = 'briefingBooks'
export const BRIEFINGS = 'briefings'
export const SCORECARDS = 'scorecards'
export const DOCUMENTS = 'files'
export const IMAGES = 'images'
export const INITIATIVES = 'initiatives'
export const REPORTS = 'reports'
export const ADMINISTRATION = 'administration'
export const GETTING_STARTED = 'gettingStarted'
export const DATASETS = 'datasets'
export const DATASET_TREES = 'datasetTrees'
export const STRATEGY_MAPS = 'strategyMaps'
export const PROJECTS = 'projects'
export const SCHEDULED_EXPORTS = 'scheduledExports'
export const CHARTS = 'charts'
export const FORMS = 'forms'
export const ORGANIZATIONS = 'organizations'
export default sections

sections.__filename__ = 'components/sections.js'
